import { MultiTenantOrganizationDetailsClients } from '@ms/yammer-graphql';

import { NormalizedMultiTenantOrganizationDetails } from './types';

type NormalizeMultiTenantOrganizationDetails = (response: {
  readonly data: MultiTenantOrganizationDetailsClients;
}) => NormalizedMultiTenantOrganizationDetails;

export const normalizeMultiTenantOrganizationDetails: NormalizeMultiTenantOrganizationDetails = (response) => ({
  multiTenantHubNetwork: response.data.viewer.multiTenantHubNetwork,
});
